module.exports = __webpack_public_path__ + "rose.e4a852fe.png";